import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@mui/material';

import { ctxRoutes } from '@/contexts/RoutesCtx';
import { dateDot } from '@/utilities/dateUtils';

export function RoutesSummaryHeader() {
  const ctx = useContext(ctxRoutes);
  const { t } = useTranslation();
  const [clicked, setClicked] = useState(!JSON.parse(sessionStorage.getItem('showRoutesSummaryTooltip') ?? 'true'));

  useEffect(() => {
    if (ctx?.highlightedRoutes?.length === 0) {
      if (clicked) sessionStorage.setItem('showRoutesSummaryTooltip', JSON.stringify(false));
      ctx?.setShowSummaryTooltip(true);
    }
  }, [ctx?.highlightedRoutes]);

  useEffect(() => {
    ctx?.setShowSummaryTooltip(false);
  }, [ctx?.routes]);

  if (!ctx || !ctx.selectedDates) return;
  return (
    <div
      className={`route-summary-card-content route-summary-head ${ctx.highlightedRoutes?.length ? 'route-summary-card-content-with-highlight' : ''}`}
      data-qa-element-id="route_summary_header"
    >
      <span>
        <span data-qa-element-id="date_interval_label">
          {dateDot(ctx.selectedDates.from, ctx.actualToTime ?? ctx.selectedDates.to, t)}:
        </span>
        <b data-qa-element-id="route_count_label">
          {ctx.highlightedRoutes?.length === 0 ? (
            ` ${ctx.routes ? ctx.routes.length : 0} ${t('routes.routeSummary')}`
          ) : (
            <>
              {` ${ctx.routes ? ctx.routes.length : 0} / `}
              <span style={{ color: 'secondary.main' }}>
                {ctx.highlightedRoutes?.length} {t('routes.routeSummaryHighlight')}
              </span>
            </>
          )}
        </b>
      </span>
      <Checkbox
        className="route-summary-checkbox"
        data-qa-element-id="route_summary_checkbox"
        onClick={() => {
          ctx.setHighlightedRoutes([]);
          setClicked(true);
        }}
        checked={ctx.highlightedRoutes?.length === ctx.routes?.length}
        indeterminate={ctx.highlightedRoutes?.length !== ctx.routes?.length}
        sx={{
          visibility: ctx.highlightedRoutes?.length !== 0 ? 'visible' : 'hidden',
          ...(!clicked && {
            boxShadow: '0px 0px 6px 6px var(--mui-palette-info-main)',
          }),
        }}
      />
    </div>
  );
}
